@if (display) {
	<p-dialog
		id="delegationsDialog"
		class="custom-dialog"
		[(visible)]="display"
		dataKey="id"
		editMode="row"
		showEffect="fade"
		[modal]="true"
		[style]="{ width: '27vw', marginTop: '0px' }"
		[breakpoints]="{
			'2000px': '50vw',
			'1800px': '50vw',
			'1700px': '50vw',
			'1600px': '50vw',
			'1500px': '50vw',
			'1400px': '50vw',
			'1300px': '50vw',
			'1200px': '55vw',
			'1000px': '60vw',
			'900px': '80vw',
			'800px': '90vw',
		}"
	>
		<ng-template pTemplate="header">
			<div style="width: 100%; text-align: center; font-weight: 600; color: #C42C22;">{{ title }}</div>
		</ng-template>
		@if (loading) {
			<div class="custom-overlay-dialog">
				<p-progressSpinner></p-progressSpinner>
			</div>
		}
		<!-- BODY -->
		<div class="" style="margin: auto; padding-left: 40px; padding-right: 40px; padding-top: 16px">
			<!-- NAME -->
			<div class="row">
				<div class="col-12">
					<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n> {{ 'general.name' | translate }} </label>
					<input
						type="text"
						name="codename"
						id="codename"
						class="form-control"
						[style]="{ width: '100%' }"
						[(ngModel)]="entity.codename"
					/>
				</div>
			</div>
			<!-- CERCALIA AUTOCOMPLETE -->
			@if (permAlm) {
				<div class="row mt-3">
					<div class="col-12">
						<label for="delegation-wharehouse" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'administration.delegations.wharehouses' | translate }}
						</label>
						<div tooltipPosition="top" pTooltip="{{ cutomersTooltip }}">
							<app-cercalia-autocomplete
								#cercaliaAutocompleteAddress
								[(localization)]="delegationLocalization"
								(newLocation)="onNewLocationSelected($event)"
								class="delegation-cercalia-autcomplete customcercalia"
							>
							</app-cercalia-autocomplete>
						</div>
					</div>
				</div>
			}
			<!-- DESCRIPTION -->
			<div class="row mt-4">
				<div class="col-12">
					<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.description' | translate }}
					</label>
					<input
						type="text"
						name="info"
						id="info"
						class="form-control"
						[style]="{ width: '100%' }"
						[(ngModel)]="entity.info"
					/>
				</div>
			</div>
			<!-- USUARIOS BO -->
			@if (permUsersBO) {
				<div class="row mt-4">
					<div class="col-12">
						<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'administration.usersbo.usersbo' | translate }}
						</label>
						<div tooltipPosition="top">
							<!-- pTooltip="{{ usersBOTooltip }}"-->
							<p-multiSelect
								[inputStyle]="{ width: '100%' }"
								[style]="{ width: '100%' }"
								[filter]="true"
								[(ngModel)]="selectedUsersBO"
								optionLabel="name"
								[options]="availableUsersBO"
								filterBy="name,surname1,surname2"
								i18n-placeholder placeholder="{{'general.selectUserApp' | translate}}"
								appendTo="body"
								dataKey="id"
								(onFocus)="utilsService.onMultiSelectFocusOrder(selectedUsersBO, availableUsersBO, 'name')"
								(onChange)="setUsersBOTooltip()"
							>
								<ng-template style="width: 100%" pTemplate="selectedItems">
									@if (!usersLoading) {
										<span>
											{{
												selectedUsersBO && selectedUsersBO.length
													? selectedUsersBO.length + ' ' + usuariosbotrad
													: NingunUsuarioBO
											}}
										</span>
									} @else {
										<p-progressSpinner [style]="{ width: '15px', height: '15px' }"></p-progressSpinner>
									}
								</ng-template>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										{{ (option?.name || '') + ' ' + (option?.surname1 || '') + ' ' + (option?.surname2 || '') }}
									</div>
								</ng-template>
							</p-multiSelect>
						</div>
					</div>
				</div>
			}
			<!-- USUARIOS APP -->
			@if (permUsersApp) {
				<div class="row mt-4">
					<div class="col-12">
						<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'administration.usersapp.usersapp' | translate }}
						</label>
						<div tooltipPosition="top">
							<!--pTooltip="{{ usersAppTooltip }}"-->
							<p-multiSelect
								[inputStyle]="{ width: '100%' }"
								[style]="{ width: '100%' }"
								[filter]="true"
								[(ngModel)]="selectedUsersApp"
								optionLabel="name"
								[options]="availableUsersApp"
								filterBy="name,surname1,surname2"
								i18n-placeholder placeholder="{{'general.selectUserApp' | translate}}"
								appendTo="body"
								dataKey="id"
								(onFocus)="utilsService.onMultiSelectFocusOrder(selectedUsersApp, availableUsersApp, 'name')"
								(onChange)="setUsersAppTooltip()"
							>
								<ng-template style="width: 100%" pTemplate="selectedItems">
									@if (!usersLoading) {
										<span>
											{{
												selectedUsersApp && selectedUsersApp.length
													? selectedUsersApp.length + ' ' + usuariosapptrad
													: NingunUsuarioApp
											}}
										</span>
									} @else {
										<ng-template [ngTemplateOutlet]="loadingIcon"></ng-template>
									}
								</ng-template>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
									{{ (option?.name || '') + ' ' + (option?.surname1 || '') + ' ' + (option?.surname2 || '') }}
								</div>
							</ng-template>
						</p-multiSelect>
					</div>
				</div>
			</div>
			}

			<!-- RUTAS -->
			@if (permRoutes) {
				<div class="row mt-4">
					<div class="col-12">
						<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'administration.routes.routes' | translate }}
						</label>
						<div tooltipPosition="top">
							<!--pTooltip="{{ routesTooltip }}"-->
							<p-multiSelect
								[inputStyle]="{ width: '100%' }"
								[style]="{ width: '100%' }"
								[filter]="true"
								[(ngModel)]="selectedRoute"
								optionLabel="name"
								[options]="availableRoutes"
								i18n-placeholder placeholder="{{'general.selectRoute' | translate}}"
								appendTo="body"
								dataKey="id"
								(onFocus)="utilsService.onMultiSelectFocusOrder(selectedRoute, availableRoutes, 'name')"
								(onChange)="setRoutesTooltip()"
							>
								<ng-template style="width: 100%" pTemplate="selectedItems">
									@if (!routesLoading) {
										<span>
											{{
												selectedRoute && selectedRoute.length
													? selectedRoute.length + ' ' + rutastrad
													: NingunaRuta
											}}
										</span>
									} @else {
										<ng-template [ngTemplateOutlet]="loadingIcon"></ng-template>
									}
								</ng-template>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										{{ option.name }}
									</div>
								</ng-template>
							</p-multiSelect>
						</div>
					</div>
				</div>
			}

			<!-- VEHICULOS -->
			@if (permVehicles) {
				<div class="row mt-4">
					<div class="col-12">
						<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ vehiculsotrad }}
						</label>
						<div tooltipPosition="top">
							<!--pTooltip="{{ vehiclesTooltip }}"-->
							<p-multiSelect
								[inputStyle]="{ width: '100%' }"
								[style]="{ width: '100%' }"
								[filter]="true"
								[(ngModel)]="selectedVehicles"
								optionLabel="name"
								[options]="availableVehicles"
								placeholder="{{ 'administration.vehicles.selectVehicle' | translate }}"
								appendTo="body"
								dataKey="id"
								(onFocus)="utilsService.onMultiSelectFocusOrder(selectedVehicles, availableVehicles, 'name')"
								(onChange)="setVehiclesTooltip()"
							>
								<ng-template style="width: 100%" pTemplate="selectedItems">
									@if (!vehiclesLoading) {
										<span>
											{{
												selectedVehicles && selectedVehicles.length
													? selectedVehicles.length + ' ' + (selectedVehicles.length === 1 ? vehiculsotrad : vehiculsotradPlural)
													: NingunVehiculo
											}}
										</span>
									} @else {
										<p-progressSpinner [style]="{ width: '15px', height: '15px' }"></p-progressSpinner>
									}
								</ng-template>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										{{ option.name }}
									</div>
								</ng-template>
							</p-multiSelect>
						</div>
					</div>
				</div>
			}
			<!-- CUSTOMERS -->
			@if (permClient) {
				<div class="row mt-4">
					<div class="col-12">
						<label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'administration.customers.customers' | translate }}
						</label>
						<div tooltipPosition="top">
							<!-- pTooltip="{{ customersTooltip }}"-->
							<p-multiSelect
								#customersMultiselect
								[inputStyle]="{ width: '100%' }"
								[style]="{ width: '100%' }"
								[filter]="true"
								[(ngModel)]="selectedCustomers"
								optionLabel="name1"
								placeholder="{{ 'administration.customers.selectClient' | translate }}"
								appendTo="body"
								dataKey="id"
								[lazy]="true"
								(onFilter)="onFilterCustomer($event)"
								[options]="availableCustomers"
								(onFocus)="utilsService.onMultiSelectFocusOrder(selectedCustomers, availableCustomers, 'name1')"
							>
								<!--
                (onChange)="setCustomersTooltip()"
                -->
								<ng-template style="width: 100%" pTemplate="selectedItems">
									@if (!customersLoading) {
										<span>
											{{
												selectedCustomers && selectedCustomers.length
													? selectedCustomers.length + ' ' + customersLabel
													: noCustomersLabel
											}}
										</span>
									} @else {
										<p-progressSpinner [style]="{ width: '15px', height: '15px' }"></p-progressSpinner>
									}
								</ng-template>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										{{ option.name1 }}
										@if (option.isDuplicate) {
											({{
												option.address1?.length > 15
													? option.address1.slice(0, 15) + '...'
													: option.address1
											}})
										}
									</div>
								</ng-template>
							</p-multiSelect>
							<!--
              <ng-select
                [items]="availableCustomers"
                bindLabel="name1"
                bindValue="id"
                [typeahead]="typeahead"
                [multiple]="true"
                [(ngModel)]="entity.customers"
                [loading]="loading"
                [hideSelected]="true"
                placeholder="Selecciona elementos"
                (scrollToEnd)="onScrollToEnd()"
                appendTo="body"
                >
              </ng-select>
              -->
						</div>
					</div>
				</div>
			}
			<!-- TYPE BOOTSTRAP -->
			<!--
      <div class="row mt-3">
        <div class="col-6 d-flex align-items-center">
          <label for="route-type" class="custom-label" i18n>
            Type
          </label>
        </div>
        <div class="col-6">
          <div class="float-end">
            <select id="route-type" class="form-select custom-select"
              [(ngModel)]="entity.type" >
              <option [ngValue]="">{{'general.selectType' | translate}}</option>
              <option *ngFor="let type of routeTypes" [ngValue]="routeType">{{ type.name }}</option>
            </select>
          </div>
        </div>
      </div>  -->
			<!--
      <div class="row mt-4">
        <div class="col-xl-6 col-md-6 mt-2">
          <div class="row align-items-center">
            <div class="col-xxl-2 col-xl-2 col-md-3  col-sm-12  text-md-end">
              <label for="deliveryNumber" class="custom-label" i18n>Tipo</label>
            </div>
            <div class="col-xxl-9 col-xl-8 col-md-8 col-sm-12">
              <form-input [required]="true" i18n-fieldName fieldName="{{'general.type' | translate}}" [errors]="errors.type">
                <p-select #ddLan id="type" i18n-placeholder placeholder="{{'administration.delegations.selectType' | translate}}"
                  [options]="availableRouteTypes" appendTo='body' [(ngModel)]="entity.type"
                filter="filter" [style]="{'width': '100%'}"></p-select>
              </form-input>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 mt-2">
          <div class="row align-items-center">
            <div class="col-xxl-3 col-xl-4 col-md-4  col-sm-12  text-md-end">
              <label for="deliveryNumber" class="custom-label" i18n>Delegación</label>
            </div>
            <div class="col-xxl-9 col-xl-8 col-md-8 col-sm-12">
              <form-input [required]="true" i18n-fieldName fieldName="{{'general.type' | translate}}" [errors]="errors.type">
                <p-select #ddLan id="type" i18n-placeholder placeholder="{{'administration.delegations.selectDelegation' | translate}}"
                  [options]="availableDelegations" appendTo='body' optionLabel="codename" dataKey="id"
                  [(ngModel)]="entity.delegation" filter="filter"
                [style]="{'width': '100%'}"></p-select>
              </form-input>
            </div>
          </div>
        </div>
      </div>
      -->
			<!-- ENABLED  SWITCH -->
			<!--
      <div class="row mt-4 mb-3">
        <div class="col-xl-6 col-md-6 mt-2">
          <div class="row align-items-center">
            <div class="col-xxl-2 col-xl-2 col-md-3  col-sm-12  text-md-end">
              <label for="deliveryNumber" class="custom-label" i18n>DELETED</label>
            </div>
            <div class="float-end col-xxl-9 col-xl-8 col-md-8 col-sm-12">
              <form-input [required]="true" i18n-fieldName fieldName="{{'general.type' | translate}}" style="float: right;"
                [errors]="errors.type">
                <p-toggleSwitch [(ngModel)]="entity.deleted"></p-toggleSwitch>
              </form-input>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 mt-2">
          <div class="row align-items-center">
            <div class="col-xxl-3 col-xl-4 col-md-4  col-sm-12  text-md-end">
            </div>
            <div class="col-xxl-9 col-xl-8 col-md-8 col-sm-12">
            </div>
          </div>
        </div>
      </div>
      --></div>
		<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center py-2">
				@if (isNew) {
					<button class="btn custom-button" (click)="saveDelegationForm()">
						{{ 'general.create' | translate }}
					</button>
				} @else {
					<button class="btn custom-button" (click)="saveDelegationForm()">
						{{ 'general.save' | translate }}
					</button>
				}
			</div>
		</ng-template>
	</p-dialog>
}
